import React from 'react'
import Sidebar from '../../../components/sidebar/Sidebar'
import Header from '../../../components/headerbar/Header'
import {config} from '../../../config'
import { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useFormik } from 'formik'
import * as yup from 'yup'
import axios from 'axios'
import _ from 'lodash'

const AddOptionList = () => {
  const navigate = useNavigate()
  const accesstoken = JSON.parse(localStorage.getItem('user'))

  // Save option list
  const handleOptionList = (formValues) => {
    const data = {
      title: formValues?.title,
      content: formValues?.content,
      image: formValues?.image,
    }
    const url = config.apiurl + '/optionlist/add'
    const configdata = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'bearer ' + accesstoken.data.access_token,
      },
    }
    const onSuccess = (res) => {
      if (res?.data?.status?.toLowerCase() === 'true') {
        toast('OptionList added successfully')
        setTimeout(() => {
          navigate('/optionlist')
        }, 2000)
      }
    }
    const onFailure = (err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", { type: "error", })
    axios.post(url, data, configdata).then(onSuccess, onFailure)
  }

  const formik = useFormik({
    initialValues: {
      title: '',
      content: '',
      image: '',
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      title: yup
        .string()
        .required('Enter the title')
        .trim()
        .min(3, 'Must be at least 3 characters long')
        .max(250, 'Max 250 characters')
        .nullable(),
      content: yup
        .string()
        .required('Enter the content')
        .trim()
        .min(3, 'Must be at least 3 characters long')
        .max(1000, 'Max 1000 characters')
        .nullable(),
      image: yup.string().required('Choose the image').nullable(),
    }),
    onSubmit: handleOptionList,
  })

  const handleImageupload = (event) => {
    const url = config.apiurl + '/upload/upload-single'
    const configdata = {
      headers: {
        'content-type': 'multipart/form-data',
        Authorization: 'bearer ' + accesstoken.data.access_token,
      },
    }
    const formData = new FormData()
    formData.append('file', event.target.files?.[0])
    const onSuccess = (res) => {
      if (res?.data?.status?.toLowerCase() === 'true') {
        toast('Image added successfully')
        formik?.setFieldValue('image', res?.data?.data?.filename)
      }
    }
    const onFailure = (err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", { type: "error", })
    axios.post(url, formData, configdata).then(onSuccess, onFailure)
  }

  return (
    <>
      <div className="min-height-300 bg-primary position-absolute w-100"></div>
      <Sidebar />
      <main className="main-content position-relative border-radius-lg ">
        <Header />
        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-12">
              <div className="card mb-4">
                <div className="card-header pb-3">
                  <div className="row">
                    <div className="col-6 d-flex align-items-center">
                      <h6 className="mb-0">Add OptionList</h6>
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Title
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="title"
                          id="title"
                          value={formik?.values?.title}
                          onChange={formik?.handleChange}
                        />
                        {formik?.errors?.title &&
                          formik?.touched?.title &&
                          formik?.errors?.title && (
                            <span className="text-danger text-gradient text-xs text-secondary">
                              {formik?.errors?.title}
                            </span>
                          )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Content
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="content"
                          id="content"
                          value={formik?.values?.content}
                          onChange={formik?.handleChange}
                        />
                        {formik?.errors?.content &&
                          formik?.touched?.content &&
                          formik?.errors?.content && (
                            <span className="text-danger text-gradient text-xs text-secondary">
                              {formik?.errors?.content}
                            </span>
                          )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label data-required="true"
                          for="files"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Image
                        </label>
                        <input
                          className="form-control"
                          type="file" accept="image/png, image/jpeg"
                          onChange={(event) => handleImageupload(event)}
                        />
                        {formik?.touched?.image && formik?.errors?.image && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            {formik?.errors?.image}
                          </span>
                        )}
                      </div>
                    </div>
                    {!_.isEmpty(formik?.values?.image) && (
                      <div className="col-md-4 imageWrapper">
                        <div>
                          <img
                            src={config?.fileurl + formik?.values?.image}
                            alt="Product Img"
                            width="150"
                            height="150"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="text-end">
                    <button
                      type="button"
                      onClick={formik?.handleSubmit}
                      className="btn btn-primary btn-sm ms-auto mt-5"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <ToastContainer />
    </>
  )
}

export default AddOptionList
